import React from 'react'

export default function ITAssets() {
  return (
    <div>ITAssets</div>
  )
}
